/**
 * to represent interaction type
 */
export enum InteractionType {
    QA = 'qa',
    SUMMARY = 'summary'
}